<template>
	<div>
		<div class="d-flex flex-wrap justify-space-between mb-4">
			<h2 class="mb-4">Dashboard</h2>
			<a
				class="v-btn v-btn--contained theme--light v-size--default success mx-2"
				:href="
					experiencePortal() + '/#/' +
					$store.state.principal.tenantSlug +
					'/' +
					$root.selectedExperience.slug
				"
				target="_blank"
			>
				Go to Experience
				<v-icon class="ml-2" color="white">mdi-arrow-right-circle</v-icon>
			</a>
		</div>
		<v-row>
			<v-col class="mb-4" cols="12" sm="4">
				<v-card class="pa-3">
					<div class="d-flex grow flex-wrap justify-space-between">
						<v-card class="d-flex justify-center align-center mt-n8" height="90px" width="90px" elevation="6" color="info">
							<v-icon size="32" color="white">mdi-account-group</v-icon>
						</v-card>
						<div class="ml-6">
							<div class="ml-auto text-right">
								<div class="body-3 grey--text font-weight-light">Total User</div>
								<h3 class="headline font-weight-light text--primary">{{ entity.totalExperienceUser }}</h3>
							</div>
						</div>
					</div>
					<v-divider class="my-4"></v-divider>
					<v-row class="px-2">
						<v-spacer></v-spacer>
						<router-link style="text-decoration: none" :to="'/tenant/experience/' + experienceId + '/user'">
							View Users
							<v-icon>mdi-chevron-right</v-icon>
						</router-link>
					</v-row>
				</v-card>
			</v-col>
			<v-col class="mb-4" cols="12" sm="4">
				<v-card class="pa-3">
					<div class="d-flex grow flex-wrap justify-space-between">
						<v-card class="d-flex justify-center align-center mt-n8" height="90px" width="90px" elevation="6" color="success">
							<v-icon size="32" color="white">mdi-store</v-icon>
						</v-card>
						<div class="ml-6">
							<div class="ml-auto text-right">
								<div class="body-3 grey--text font-weight-light">Total Booth</div>
								<h3 class="headline font-weight-light text--primary">{{ entity.totalExperienceBooth }}</h3>
							</div>
						</div>
					</div>
					<v-divider class="my-4"></v-divider>
					<v-row class="px-2">
						<v-spacer></v-spacer>
						<router-link style="text-decoration: none" :to="
								'/tenant/experience/' + experienceId + '/booth'
							">
							View Booths
							<v-icon>mdi-chevron-right</v-icon>
						</router-link>
					</v-row>
				</v-card>
			</v-col>
			<v-col class="mb-4" cols="12" sm="4">
				<v-card class="pa-3">
					<div class="d-flex grow flex-wrap justify-space-between">
						<v-card class="d-flex justify-center align-center mt-n8" height="90px" width="90px" elevation="6" color="warning">
							<v-icon size="32" color="white">mdi-presentation</v-icon>
						</v-card>
						<div class="ml-6">
							<div class="ml-auto text-right">
								<div class="body-3 grey--text font-weight-light">Total Presentation</div>
								<h3 class="headline font-weight-light text--primary">{{ entity.totalExperiencePresentation }}</h3>
							</div>
						</div>
					</div>
					<v-divider class="my-4"></v-divider>
					<v-row class="px-2">
						<v-spacer></v-spacer>
						<router-link style="text-decoration: none" :to="
								'/tenant/experience/' +
								experienceId +
								'/presentation'
							">
							View Presentations
							<v-icon>mdi-chevron-right</v-icon>
						</router-link>
					</v-row>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			entity: {}
		};
	},
	computed: {
		experienceId() {
			return this.$route.params.experienceId;
		}
	},
	mounted() {
		this.getDashboardData();
	},
	methods: {
		getDashboardData() {
			axios
				.post("/system/dashboard/data", {
					experienceId: this.experienceId
				})
				.then(response => {
					this.entity = response.data;
					this.$root.selectedExperience = response.data.selectedExperience;
				})
				.catch(() => {});
		},
		experiencePortal() {
			let origin = window.location.origin;
			if (origin.startsWith('https://administrator.')) {
				return 'https://' + origin.slice('https://administrator.'.length);
			} else if (origin.startsWith('https://tenant.')) {
				return 'https://' + origin.slice('https://tenant.'.length);
			}
			return '';
		}
	}
};
</script>
